<template>
  <div
    v-if="visible"
    class="tjrd-w-overlay"
    id="tjrd-w-overlay"
    @click.self="close"
  >
    <canvas ref="confettiCanvas" class="tjrd-w-canvas"></canvas>
    <div
      class="tjrd-w-popup"
      role="dialog"
      aria-modal="true"
      aria-label="Misiones TuJugada RD"
    >
      <div class="tjrd-w-hero">
        <button class="tjrd-w-close" @click="close" aria-label="Cerrar">
          ✕
        </button>

        <img
          class="tjrd-w-logo"
          src="@/assets/images/admin/banner.png"
          alt="Tu Jugada RD"
        />

        <div class="tjrd-w-icon-wrap">
          <div class="tjrd-w-icon-bg"><span>🎯</span></div>
        </div>

        <h2>¡Hay bonos<br /><em>esperándote!</em></h2>

        <div class="tjrd-w-stats">
          <div class="tjrd-w-stat">
            <span class="tjrd-w-stat-val">{{ availableCount }}</span>
            <span class="tjrd-w-stat-lbl">misiones<br />disponibles</span>
          </div>
          <div class="tjrd-w-stat">
            <span class="tjrd-w-stat-val">${{ availableBonuses }}</span>
            <span class="tjrd-w-stat-lbl">RD en bonos<br />por ganar</span>
          </div>
        </div>
      </div>

      <div class="tjrd-w-body">
        <p class="tjrd-w-desc">
          Completa sencillas misiones dentro de tu perfil<br />
          y acumula hasta <strong>${{ availableBonuses }} RD en bonos</strong
          ><br />
          redimibles en la plataforma. ¡Es tu momento!
        </p>

        <a class="tjrd-w-cta" href="javascript:void(0)" @click="goToMissions">
          <span class="tjrd-w-cta-icon">🚀</span>
          <div class="tjrd-w-cta-text">
            <strong>¡Quiero mis bonos ahora!</strong>
            <span>Ver mis misiones y empezar a ganar</span>
          </div>
          <div class="tjrd-w-cta-arrow">→</div>
        </a>

        <button class="tjrd-w-skip" @click="close">
          Ahora no, continuar a la plataforma
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "@/event";
import { restClient } from "@/utils/restClient";

export default {
  name: "MissionsWelcomePopup",
  data() {
    return {
      visible: false,
      availableCount: 4,
      availableBonuses: 600,
      animFrame: null,
    };
  },
  mounted() {
    EventBus.$on("check-missions-popup", this.checkAndShow);
  },
  beforeDestroy() {
    EventBus.$off("check-missions-popup", this.checkAndShow);
    this.stopConfetti();
  },
  methods: {
    async checkAndShow() {
      try {
        const response = await restClient(
          `${process.env.VUE_APP_API_URL}/missions/status`,
          "GET",
          null,
          { _t: new Date().getTime() }
        );

        if (response && response.data && response.data.active) {
          const missions = response.data.missions || {};
          let count = 0;
          let totalBonus = 0;

          [1, 2, 3, 4].forEach((key) => {
            const m = missions[key] || {
              completed: false,
              paid: false,
              amount: 0,
            };
            if (!m.completed && !m.paid) {
              count++;
              const amount = Number(m.amount) || 0;
              if (amount > 0) {
                totalBonus += amount;
              }
            }
          });

          // Show popup only if user has pending missions to complete
          if (count > 0) {
            this.availableCount = count;
            this.availableBonuses = totalBonus;
            this.visible = true;
            this.$nextTick(() => {
              this.initConfetti();
            });
          }
        }
      } catch (error) {
        console.error("Error checking missions status for popup:", error);
      }
    },
    close() {
      this.visible = false;
      this.stopConfetti();
    },
    goToMissions() {
      this.close();
      if (this.$route.name !== "profile") {
        this.$router.push({ name: "profile" });
      }
    },
    initConfetti() {
      const canvas = this.$refs.confettiCanvas;
      if (!canvas) return;
      const ctx = canvas.getContext("2d");
      let W = (canvas.width = canvas.parentElement
        ? canvas.parentElement.offsetWidth
        : window.innerWidth);
      let H = (canvas.height = canvas.parentElement
        ? canvas.parentElement.offsetHeight
        : window.innerHeight);

      const particles = [];
      const colors = [
        "#5B3B8C",
        "#00E5A0",
        "#8A6DBF",
        "#00C988",
        "#3B2466",
        "#fff",
      ];

      const handleResize = () => {
        if (canvas && canvas.parentElement) {
          W = canvas.width = canvas.parentElement.offsetWidth;
          H = canvas.height = canvas.parentElement.offsetHeight;
        }
      };

      window.addEventListener("resize", handleResize);

      for (let i = 0; i < 50; i++) {
        particles.push({
          x: Math.random() * W,
          y: Math.random() * H - H,
          r: Math.random() * 4 + 2,
          d: Math.random() * 1.4 + 0.5,
          color: colors[Math.floor(Math.random() * colors.length)],
          tiltAngle: 0,
          tiltSpeed: Math.random() * 0.06 + 0.02,
          shape: Math.random() > 0.5 ? "rect" : "circle",
          alpha: Math.random() * 0.35 + 0.15,
        });
      }

      const draw = () => {
        ctx.clearRect(0, 0, W, H);
        particles.forEach((p) => {
          ctx.save();
          ctx.globalAlpha = p.alpha;
          ctx.fillStyle = p.color;
          ctx.translate(p.x, p.y);
          ctx.rotate(p.tiltAngle);
          if (p.shape === "rect") {
            ctx.fillRect(-p.r / 2, -p.r / 2, p.r, p.r * 2);
          } else {
            ctx.beginPath();
            ctx.arc(0, 0, p.r / 2, 0, Math.PI * 2);
            ctx.fill();
          }
          ctx.restore();
        });
      };

      const update = () => {
        particles.forEach((p) => {
          p.y += p.d;
          p.tiltAngle += p.tiltSpeed;
          p.x += Math.sin(p.tiltAngle) * 0.5;
          if (p.y > H + 10) {
            p.y = -10;
            p.x = Math.random() * W;
          }
        });
      };

      const loop = () => {
        draw();
        update();
        this.animFrame = requestAnimationFrame(loop);
      };

      if (window.matchMedia("(prefers-reduced-motion:reduce)").matches) {
        canvas.style.display = "none";
      } else {
        loop();
      }
    },
    stopConfetti() {
      if (this.animFrame) {
        cancelAnimationFrame(this.animFrame);
        this.animFrame = null;
      }
    },
  },
};
</script>

<style scoped>
.tjrd-w-overlay {
  position: fixed;
  inset: 0;
  z-index: 9998;
  background: rgba(13, 10, 30, 0.6);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  animation: tjrd-w-fi 0.25s ease;
}
@keyframes tjrd-w-fi {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.tjrd-w-canvas {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 0;
}
.tjrd-w-popup {
  position: relative;
  z-index: 1;
  font-family: "Inter", sans-serif;
  background: var(--card-shop-bg, #ffffff);
  border-radius: 24px;
  width: 100%;
  max-width: 340px;
  overflow: hidden;
  box-shadow: 0 20px 50px rgba(91, 59, 140, 0.3), 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1.5px solid var(--card-shop-shadow, rgba(91, 59, 140, 0.2));
  animation: tjrd-w-su 0.32s cubic-bezier(0.22, 0.68, 0, 1.2);
}
@keyframes tjrd-w-su {
  from {
    transform: translateY(28px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* HERO */
.tjrd-w-hero {
  background: linear-gradient(145deg, #2e1a55 0%, #5b3b8c 60%, #7050a8 100%);
  padding: 26px 24px 20px;
  position: relative;
  overflow: hidden;
  text-align: center;
}
.tjrd-w-hero::before {
  content: "";
  position: absolute;
  top: -50px;
  right: -50px;
  width: 160px;
  height: 160px;
  background: radial-gradient(
    circle,
    rgba(0, 229, 160, 0.2) 0%,
    transparent 70%
  );
  pointer-events: none;
}
.tjrd-w-hero::after {
  content: "";
  position: absolute;
  bottom: -40px;
  left: -30px;
  width: 120px;
  height: 120px;
  background: radial-gradient(
    circle,
    rgba(255, 255, 255, 0.07) 0%,
    transparent 70%
  );
  pointer-events: none;
}

.tjrd-w-close {
  position: absolute;
  top: 11px;
  right: 11px;
  z-index: 2;
  background: rgba(255, 255, 255, 0.13);
  border: none;
  color: #fff;
  font-size: 13px;
  cursor: pointer;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
}
.tjrd-w-close:hover {
  background: rgba(255, 255, 255, 0.25);
}

.tjrd-w-logo {
  height: 22px;
  width: auto;
  display: block;
  margin: 0 auto 16px;
  position: relative;
  z-index: 1;
}

.tjrd-w-icon-wrap {
  position: relative;
  z-index: 1;
  margin-bottom: 14px;
}
.tjrd-w-icon-bg {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  border: 2px solid rgba(0, 229, 160, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  animation: tjrd-w-pulse 2s ease-in-out infinite;
}
@keyframes tjrd-w-pulse {
  0%,
  100% {
    box-shadow: 0 0 0 0 rgba(0, 229, 160, 0.3);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(0, 229, 160, 0);
  }
}
.tjrd-w-icon-bg span {
  font-size: 30px;
  line-height: 1;
}

.tjrd-w-hero h2 {
  font-family: "Inter", sans-serif;
  font-size: 18px;
  font-weight: 900;
  color: #fff;
  line-height: 1.25;
  margin: 0 0 0;
  position: relative;
  z-index: 1;
}
.tjrd-w-hero h2 em {
  font-style: normal;
  color: #00e5a0;
}

/* STATS ROW */
.tjrd-w-stats {
  display: flex;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  position: relative;
  z-index: 1;
  margin-top: 16px;
}
.tjrd-w-stat {
  flex: 1;
  text-align: center;
  padding: 11px 8px;
}
.tjrd-w-stat + .tjrd-w-stat {
  border-left: 1px solid rgba(255, 255, 255, 0.1);
}
.tjrd-w-stat-val {
  font-family: "Inter", sans-serif;
  font-size: 20px;
  font-weight: 900;
  color: #00e5a0;
  line-height: 1;
  display: block;
  margin-bottom: 3px;
}
.tjrd-w-stat-lbl {
  font-family: "Inter", sans-serif;
  font-size: 10px;
  color: rgba(255, 255, 255, 0.6);
  line-height: 1.3;
  display: block;
}

/* BODY */
.tjrd-w-body {
  padding: 18px 20px 22px;
}
.tjrd-w-desc {
  font-family: "Inter", sans-serif;
  font-size: 13px;
  color: var(--text-muted, #5a5a7a);
  line-height: 1.55;
  text-align: center;
  margin: 0 0 16px;
}
.tjrd-w-desc strong {
  color: var(--text, #3b2466);
}

/* CTA */
.tjrd-w-cta {
  display: flex;
  align-items: center;
  gap: 10px;
  background: linear-gradient(135deg, #5b3b8c, #3b2466);
  border-radius: 14px;
  padding: 14px 16px;
  text-decoration: none;
  transition: filter 0.2s, transform 0.15s, box-shadow 0.2s;
  box-shadow: 0 5px 18px rgba(91, 59, 140, 0.4);
}
.tjrd-w-cta:hover {
  filter: brightness(1.1);
  transform: translateY(-2px);
  box-shadow: 0 10px 26px rgba(91, 59, 140, 0.5);
}
.tjrd-w-cta-icon {
  font-size: 22px;
  flex-shrink: 0;
}
.tjrd-w-cta-text {
  flex: 1;
}
.tjrd-w-cta-text strong {
  display: block;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 900;
  color: #fff;
  margin-bottom: 2px;
}
.tjrd-w-cta-text span {
  font-family: "Inter", sans-serif;
  font-size: 10px;
  color: rgba(255, 255, 255, 0.6);
}
.tjrd-w-cta-arrow {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: #00e5a0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  color: #2e1a55;
  font-weight: 900;
  flex-shrink: 0;
  transition: transform 0.2s;
}
.tjrd-w-cta:hover .tjrd-w-cta-arrow {
  transform: translateX(3px);
}

.tjrd-w-skip {
  display: block;
  text-align: center;
  margin-top: 10px;
  font-family: "Inter", sans-serif;
  font-size: 10px;
  color: var(--text-muted, #b0a8cc);
  cursor: pointer;
  background: none;
  border: none;
  width: 100%;
  transition: color 0.15s;
  padding: 0;
}
.tjrd-w-skip:hover {
  color: var(--text, #5b3b8c);
}
</style>
